import {Box, styled, SxProps} from "@mui/material";
import React from "react";
import {GOCCIA_RIFLESSO} from "../../../constants/svgs";
import theme, {FONTS} from "../../../constants/theme";
import CustomSvg from "../../custom-svg";
import Text from "../../text";
import {scale} from "../../../utils";

interface Props {
  sx?: SxProps;
}

const Wrapper = styled(Box)({
  display: "flex",
  justifyContent: 'center',
  gap: scale(25),
  width: scale(280),
  height: scale(40),
  borderRadius: scale(8),
});

const CalendarLegend = ({sx}: Props) => {
  return (
    <Wrapper sx={sx}>
      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
        <CustomSvg
          svg={GOCCIA_RIFLESSO}
          cls1Color={theme.palette.blood.main}
          sx={{
            height: scale(27.4),
            width: 'auto',
          }}
        />
        <Text
          text={'Sangue'}
          fontFamily={FONTS.MONTSERRAT}
          fontSize={scale(16)}
          fontWeight={500}
          color={theme.palette.ceramic.contrastText}
          sx={{
            maxWidth:'74%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
          }}
        />
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
        <CustomSvg
          svg={GOCCIA_RIFLESSO}
          cls1Color={theme.palette.plasma.main}
          sx={{
            height: scale(27.4),
            width: 'auto',
          }}
        />
        <Text
          text={'Plasma'}
          fontFamily={FONTS.MONTSERRAT}
          fontSize={scale(16)}
          fontWeight={500}
          color={theme.palette.ceramic.contrastText}
          sx={{
            maxWidth:'74%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
          }}
        />
      </div>
    </Wrapper>
  )
}

export default CalendarLegend;
